import coreSlice from "./slices/core";
import errorSlice from "./slices/error";
import modalSlice from "./slices/modal";
import sessionSlice from "./slices/session";
import toastsSlice from "./slices/toasts";

/** The slices that every client store registers. See `kioskSlices` and `mobileSlices`. */
export const commonSlices = {
  core: coreSlice,
  toasts: toastsSlice,
  modal: modalSlice,
  error: errorSlice,
  session: sessionSlice
};
